import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { User } from 'oidc-client-ts';
import { useAuth } from 'react-oidc-context';

import { appConfig } from 'utilities/env';

export type AuthUser = User['profile'] & {
  // JSON-encoded `LicenseInfoEntry[]`.
  license_info?: string;
};

const fetchUserInfo = async (user: User) => {
  const { data } = await axios.get(`${appConfig.kcAuthority}/protocol/openid-connect/userinfo`, {
    headers: {
      Authorization: `Bearer ${user.access_token}`,
    },
  });
  return data;
};

const useAuthUser = () => {
  const { user, isLoading } = useAuth();

  return useQuery<AuthUser, Error>({
    queryKey: ['authProfile'],
    queryFn: () => fetchUserInfo(user as User),
    enabled: !isLoading && !!user,
  });
};

export default useAuthUser;
